import { Trans } from '@lingui/react'
import classNames from 'clsx'

// @ts-ignore
const AvailabilityStatus = ({ available }) => {
  return (
    <div
      className={classNames(
        {
          'u-color--positive o-ProductInfo__availability-available': available,
          'u-color--info-dark o-ProductInfo__availability-not-available':
            !available,
        },
        'u-font-weight--bold o-ProductInfo__availability'
      )}
    >
      {available ? (
        <Trans id="general.label.product.available" />
      ) : (
        <Trans id="general.label.product.currentlyNotAvailable" />
      )}
    </div>
  )
}

export default AvailabilityStatus
